// frontend/src/services/socrates/parameterService.js

import { apiService } from '../api';
import { API_ENDPOINTS } from '../../config/constants';

export const parameterService = {
  // Get all plato parameters from backend
  getParameters: async () => {
    try {
      const response = await apiService.get(API_ENDPOINTS.AGENTS.PARAMETERS.GET);
      
      // Parse the response body if it's a string
      let parsedData;
      if (typeof response.body === 'string') {
        parsedData = JSON.parse(response.body);
      } else {
        parsedData = response;
      }
      
      const parameters = parsedData.parameters || [];
      
      // Transform the parameters to include necessary metadata
      const transformedParameters = parameters.map(param => ({
        parameter_id: `${param.category_name}_${param.parameter_name}`,
        category_name: param.category_name,
        parameter_name: param.parameter_name,
        parameter_type: 'object', // These are all selection-based parameters
        description: `Select from available ${param.parameter_name.replace(/_/g, ' ')} options`,
        parameter_values: param.parameter_values || [],
        is_required: false,
        default_value: 'system_default'
      }));
      
      console.log('Transformed parameters:', transformedParameters);
      return transformedParameters;
    } catch (error) {
      console.error('Error fetching parameters:', error);
      throw error;
    }
  },

  // Map values to dropdown UI format
  getParameterOptions: async (parameter) => {
    if (!parameter || !Array.isArray(parameter.parameter_values)) {
      return [];
    }

    return parameter.parameter_values
      .filter(val => val.status === 'active') // Only include active values
      .map(val => ({
        value: val.value_key,
        label: val.description || val.value_key,
        isActive: val.status === 'active'
      }));
  },

  // Get options for a specific parameter by name
  getParameterOptionsByName: async (parameterName) => {
    try {
      const parameters = await parameterService.getParameters();
      const parameter = parameters.find(p => 
        p.parameter_name === parameterName || 
        p.parameter_id === parameterName
      );
      
      if (parameter) {
        return await parameterService.getParameterOptions(parameter);
      }
      
      return [];
    } catch (error) {
      console.error(`Error getting options for parameter ${parameterName}:`, error);
      return [];
    }
  },

  // Get parameter by category name
  getParameterByCategory: async (categoryName) => {
    try {
      const parameters = await parameterService.getParameters();
      return parameters.find(p => p.category_name === categoryName);
    } catch (error) {
      console.error(`Error getting parameter for category ${categoryName}:`, error);
      return null;
    }
  }
};

export default parameterService;